// Admin AppBar.

import React from 'react';
import { Stack, Box } from '@mui/material';
// import Config from '../lib/Config';
import { useEffect, useState } from 'react';
import '../../assets/style/fonts.css';
// import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export default (props) => {

    //const navigate = useNavigate();


    return (
        <table style={{height:'30px',border:'none',margin:'0px auto'}}>
            <tr>
                { props.prev_section ? <td style={{width:'30px',fontSize:'13px',textAlign:'center',color:'#222222',verticalAlign:'center',paddingTop:'4px'}}><ArrowBackIosNewIcon style={{fontSize:'13px',color:'#222222',margin:'0px',paddingTop:'0px',cursor:'pointer'}}  onClick={()=>{props.clicked(1)}} /></td> : <></> }
                {props.pages.map((item)=><> { item == props.current_page ? <td style={{width:'30px',fontSize:'13px',textAlign:'center',color:'#222222'}}><div style={{width:'26px',height:'26px',margin:'0px',padding:'0px',lineHeight:'26px',backgroundColor:'#f2f2f2',borderRadius:'8px'}}>{item}</div></td> : <td style={{width:'30px',fontSize:'13px',textAlign:'center',cursor:'pointer',color:'#222222'}} onClick={()=>{props.clicked(item)}}>{item}</td> } </>)}
                { props.next_section ? <td style={{width:'30px',fontSize:'13px',textAlign:'center',color:'#222222',verticalAlign:'center',paddingTop:'4px'}}><ArrowForwardIosIcon style={{fontSize:'13px',color:'#222222',margin:'0px',paddingTop:'0px',cursor:'pointer'}} onClick={()=>{props.clicked(1)}} /></td> : <></> }
            </tr>
        </table>
    );

}